<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;margin-top:-50px;">
	

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')">
       
         <el-table-column
        
          prop="id" align="center" width="400">
        <template slot-scope="scope">
             {{scope.row.id}} <el-checkbox true-label="1" false-label="0" v-model="scope.row.init"></el-checkbox>V{{scope.row.gubun}} {{$t('msg.팝업')}}{{scope.row.location}} 
          </template>
      </el-table-column> 

     
   
     
      <el-table-column
        
       prop="subject" align="center" >
         <template slot-scope="scope">
              <mavon-editor
                      :placeholder="$t('status.편집')"
                      ref="editor"
                      v-model="scope.row.contentString"
                         @imgAdd="imgAdd"
                            @change="change"
                      :subfield="true"
                      style="height:600px;"
                     >
                   </mavon-editor>
          </template>
      </el-table-column> 
      <el-table-column
      align="center" width="400">
      <template slot-scope="scope">
        
          <el-button type="primary" size="mini" @click="editContent(scope)">{{$t('tableText.수정')}}</el-button>
        
        
      </template>
      </el-table-column>
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
      
				
</div>
 </template>

 <script>

 import {mavonEditor} from "mavon-editor";
 import "mavon-editor/dist/css/index.css";
      
    export default {
     components: {
      mavonEditor
    },
    	data(){
    		return{
           html:'',
    		  domain:window.sessionStorage.getItem('domain'),
    			searchform:{
    				keyword:'',
    				time:[],
    				searchOptions:[
                
    				{
		        	label:this.$i18n.t("msg.아이디"),
		        	value:'mem_id'
		        },
            

		        ],
		       
            
		        value:'',
          

      


    			},
    			 pickerOptions: {
    			},
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
    
       
    			
		        
    		
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
		    		 tableData: [],
			       currentPage:1,
			       multipleSelection:[],
             checked:'1',
          
			        
			         
			 
    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
 
    	methods:{
         change(value, render) {
         // render 为 markdown 解析后的结果
           console.log('render',render);
           this.html = render;
       },
　// 绑定@imgAdd event
　　　　　　imgAdd(pos, $file){
            
             const isLt2M = $file.size / 1024 / 1024 < 2;

              
              if (!isLt2M) {
               this.$message.error(this.$i18n.t("msg.크기보다작아야함"));
                this.$refs.editor.$img2Url(pos,"");
                return;
              }


             let token=window.sessionStorage.getItem('user');
       
　　　　　　　　// 第一步.图片上传到服务器.
　　　　　　　　var formdata = new FormData();
　　　　　　　　formdata.append('file', $file);
　　　　　　　　this.$axios({
　　　　　　　　　　url: this.domain+'/admin/fileu',
　　　　　　　　　　method: 'post',
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
　　　　　　　　　　data: formdata,
　　　　　　　　　
　　　　　　　　}).then((url) => {
　　　　　　　　　　// 第二步.将返回的url替换到文本原位置![...](0) -> ![...](url)
　　　　　　　　　 // console.log('url',url);
　　　　　　　　　　this.$refs.editor.$img2Url(pos, url.data.data);
　　　　　　　　})
　　　　　　},
        editContent(e){
          let token=window.sessionStorage.getItem('user');
           this.$axios({
                      method:'post',
                      url:this.domain+'/admin/pop_up',
                      data:{
                          contentString:this.html,
                          id:e.row.id,
                          init:e.row.init,
                      
                         
                        },   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                   if(response.data.code==200){
                       
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })   
                    }
                    this.getList()
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
         
            
         
        },
   
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			    
       
    		getList(){

    	

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/poplist?page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                   
                     let data = response.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     
                     this.loading =false
               
            }).catch((error) =>{
            	
                 this.$message.error(error);
              this.loading = false
               
            })
    		},
    
    		  
    
    	}
  }
</script>

 <style scoped>
/deep/ .v-note-wrapper{
  min-height:200px;
}

</style>


// WEBPACK FOOTER //
// src/views/pop/list.vue